/**
 * GroupProfileDomHelpers
 *
 * Shared DOM query utilities and selectors for GroupProfile controllers.
 * Centralizes common selectors to avoid magic strings across controllers.
 */

export const GroupProfileDomHelpers = {
  selectors: {
    formInputs:
      ".product-group-profile-select, .product-group-profile-checkbox, .product-group-profile-quantity",
    selectInputs: ".product-group-profile-select",
    checkboxInputs: ".product-group-profile-checkbox",
    quantityInputs: ".product-group-profile-quantity",
    roomAssignmentContainer:
      ".border.border-gray-200.rounded-lg.overflow-hidden.mb-6",
    selectedRoom: ".border-green-500.bg-green-50",
    groupSummary: ".product-group-profile-summary",
    validationError: ".product-group-profile-validation-error",
    bookingSummary: ".product-group-profile-booking-summary",
    accommodationSection: '[data-resource-type="accommodation"]',
  },

  findFormInputs(container) {
    return container.querySelectorAll(this.selectors.formInputs);
  },

  findGroupInputs(container, groupId) {
    return container.querySelectorAll(
      `[data-group-id="${groupId}"]${this.selectors.formInputs}`
    );
  },

  findRoomAssignmentContainers(container) {
    return container.querySelectorAll(this.selectors.roomAssignmentContainer);
  },

  findSelectedRooms(container) {
    const roomContainers = this.findRoomAssignmentContainers(container);
    return Array.from(roomContainers).filter((roomContainer) => {
      return roomContainer.querySelector(this.selectors.selectedRoom);
    });
  },

  findValidationErrorForInput(input) {
    const container =
      input.closest(".product-group-profile-group") ||
      input.closest(".product-group-profile-option");
    return container
      ? container.querySelector(this.selectors.validationError)
      : null;
  },

  findGroupSummary(container, groupId) {
    return container.querySelector(
      `${this.selectors.groupSummary}[data-group-id="${groupId}"]`
    );
  },

  isInAccommodationSection(element) {
    return element.closest(this.selectors.accommodationSection) !== null;
  },

  findHeightContainers(container) {
    return container.querySelectorAll("[data-height-container]");
  },

  dispatchEvent(element, eventName, detail = {}) {
    const event = new CustomEvent(eventName, {
      bubbles: true,
      cancelable: true,
      detail,
    });
    element.dispatchEvent(event);
  },
};

export default GroupProfileDomHelpers;
